import ContainerRight from './ContainerRight'

export default ContainerRight
